"use strict";var e=require("./components/Accordion.js"),o=require("./components/AccordionDetail.js"),r=require("./components/AccordionItem.js"),c=require("./components/AccordionHeader.js"),t=require("./components/AccordionTitle.js"),i=require("./components/AccordionSubTitle.js");exports.Accordion=e.default,exports.AccordionDetail=o.default,exports.AccordionItem=r.default,exports.AccordionHeader=c.default,exports.AccordionTitle=t.default,exports.AccordionSubTitle=i.default;



//////////////////
// WEBPACK FOOTER
// ./~/@vds/accordions/cjs/index.js
// module id = 232
// module chunks = 0